import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import pointer from "../assets/images/pointer.png";
import pencil from "../assets/images/pencil.png";
import painting from "../assets/images/painting.png";

export default function HeroSection({ language, texts }) {
    const [showVideo, setShowVideo] = useState(false);
    const [typingDone, setTypingDone] = useState(false);

    // ページロードから5秒で動画表示
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowVideo(true);
        }, 4000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <section className="relative w-full h-[80vh] flex justify-center items-center bg-[#94edfe] px-4 md:px-16">
            <motion.img
                src={pencil}
                alt="floating pencil"
                onContextMenu={(e) => e.preventDefault()}
                className="absolute w-32 top-10 left-10"
                animate={{ y: [200, 30, 0], rotate: [10, 30, 0] }}
                transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
            />
            <motion.img
                src={painting}
                alt="floating origami"
                onContextMenu={(e) => e.preventDefault()}
                className="absolute w-48 bottom-16 right-20"
                animate={{ y: [80, 50, 0], rotate: [-10, 10, 0] }}
                transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
            />

            {!showVideo && (
                <div className="relative z-20 flex w-full max-w-xl">

                    <motion.img
                        src={pointer}
                        alt="click pointer"
                        onContextMenu={(e) => e.preventDefault()}
                        className="absolute -bottom-10 right-4 w-10 h-10"
                        animate={{
                            y: [0, 8, 0],
                            scale: [1, 0.9, 1],
                            opacity: [1, 0.8, 1]
                        }}
                        transition={{
                            duration: 0.8,
                            repeat: Infinity,
                            repeatDelay: 0.3,
                            ease: "easeInOut"
                        }}
                    />

                    <div className="flex-1 p-4 rounded-l-lg border-2 border-white text-base md:text-lg focus:outline-none bg-white/30">
                        {/* Typewriter表示 */}
                        <Typewriter
                            words={[texts.typingwords]}
                            loop={1}
                            cursor
                            cursorStyle="|"
                            typeSpeed={40}
                            deleteSpeed={0}
                            delaySpeed={500}
                            onDone={() => setTypingDone(true)}
                        />
                    </div>

                    <div
                        className={`px-4 rounded-r-lg font-semibold transition-colors duration-300 flex items-center justify-center cursor-pointer ${typingDone ? "bg-[#b5435f] text-white" : "bg-white text-[#b5435f]"
                            }`}
                    >
                        {language === "JP" ? "検索" : language === "ZH" ? "搜索" : "Search"}
                    </div>
                </div>
            )}

            {/* 動画 */}
            {showVideo && (
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5 }}
                    className="relative z-10 w-full max-w-4xl md:max-w-3xl lg:max-w-2xl aspect-video border-4 border-white rounded-lg overflow-hidden shadow-lg mt-20"
                >
                    <iframe
                        className="absolute inset-0 w-full h-full"
                        src="https://www.youtube.com/embed/FLz6NAqRVPo"
                        title="Hanapin 樱花老师"
                        allow="autoplay; fullscreen"
                        allowFullScreen
                    ></iframe>
                </motion.div>

            )}
        </section>
    );
}
